import { AppNavigationProvider } from '@euler/app/components/AppNavigationProvider';
import { Panel } from '@euler/app/tv/components/Panel';
import { SearchCriteriaScreen } from '@euler/app/tv/components/search/SearchCriteraPanel';
import { SearchCriterionOptionSelectorScreen } from '@euler/app/tv/components/search/SearchCriterionOptionSelector';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { LayoutProviderView } from '@euler/components/layout/LayoutProvider';
import { useTrackNavigator } from '@euler/functions/navigatorTracking';
import { ScreenToParams, spreadScreens } from '@euler/functions/spreadScreens';
import { DefaultTheme, NavigationContainer } from '@react-navigation/native';
import {
  createStackNavigator,
  StackNavigationOptions,
  TransitionPresets,
} from '@react-navigation/stack';
import { memo } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

const Stack = createStackNavigator();

const SearchCriteriaScreens = {
  _criteria: SearchCriteriaScreen,
  _options: SearchCriterionOptionSelectorScreen,
};

export type SearchCriteriaNavParams = ScreenToParams<
  typeof SearchCriteriaScreens
>;

const screenOptions: StackNavigationOptions = {
  ...TransitionPresets.SlideFromRightIOS,
  headerShown: false,
  cardOverlayEnabled: false,
  cardShadowEnabled: false,
};

export const SearchCriteriaContainer = memo(
  ({ style }: { style?: StyleProp<ViewStyle> }) => {
    const theme = usePresentationTheme();

    const { ref, onStateChange, onReady } =
      useTrackNavigator('tv/tasks/search/');

    return (
      <AppNavigationProvider>
        <LayoutProviderView
          fallbackToChildren
          css={`
            flex: 1;
          `}
          style={style}
        >
          <Panel
            css={`
              flex: 1;
            `}
            contentContainerStyle={{
              flex: 1,
              paddingLeft: 0,
              paddingRight: 0,
              paddingBottom: 0,
              paddingTop: 0,
            }}
          >
            <NavigationContainer
              documentTitle={{ enabled: false }}
              ref={ref}
              onReady={onReady}
              onStateChange={onStateChange}
              independent={true}
              theme={{
                dark: false,
                colors: {
                  ...DefaultTheme.colors,
                  primary: theme.panel.bg,
                  background: theme.panel.bg,
                },
              }}
            >
              <Stack.Navigator
                screenOptions={{
                  ...screenOptions,
                  cardStyle: {
                    overflow: 'hidden',
                    backgroundColor: theme.panel.bg,
                  },
                  cardOverlay: () => <View />,
                }}
                initialRouteName={'_criteria'}
              >
                {spreadScreens(
                  Stack.Screen,
                  SearchCriteriaScreens,
                  '_criteria',
                )}
              </Stack.Navigator>
            </NavigationContainer>
          </Panel>
        </LayoutProviderView>
      </AppNavigationProvider>
    );
  },
);
